import React from "react";
import { useIdea } from "../context/IdeaContext";

const ModuleHeader = ({
  title,
  subtitle,
  currentModule,
  isLoadedFromDB = false
}) => {
  const { selectedIdea } = useIdea();

  return (
    <div className="max-w-6xl mx-auto px-4 space-y-8">

      {/* HERO */}
      <div className="relative">

        <div className="border-b border-slate-200 pb-6">

          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-bold leading-tight">
            <span className="text-slate-800">{title}</span>{" "}
            <span className="bg-gradient-to-r from-blue-600 to-indigo-500 bg-clip-text text-transparent">
              Workspace
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-slate-600 mt-3 max-w-2xl text-base md:text-lg leading-relaxed">
            {subtitle}
          </p>

          {/* Optional Module Tag */}
          {currentModule && (
            <div className="mt-3 inline-block text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">
              {currentModule}
            </div>
          )}

        </div>
      </div>


      {/* ACTIVE IDEA CONTEXT */}
      {selectedIdea && (
        <div className="bg-white/70 backdrop-blur-md border border-slate-200 rounded-2xl p-5 shadow-soft hover:shadow-md transition-all duration-300 transition">

          <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-4">

            {/* LEFT */}
            <div className="flex-1">

              <div className="text-xs font-semibold text-blue-600 mb-1 tracking-wide">
                ACTIVE IDEA
              </div>

              <h3 className="text-lg md:text-xl font-semibold text-slate-800 leading-snug">
                {selectedIdea.ideaTitle}
              </h3>

              <p className="text-sm text-slate-600 mt-1 max-w-xl">
                {selectedIdea.solution}
              </p>
            </div>


            {/* STATUS */}
            <div className="flex-shrink-0">
              {isLoadedFromDB ? (
                <div className="bg-amber-100 text-amber-800 px-3 py-1.5 rounded-full text-xs font-medium">
                  ⏳ Previous Session
                </div>
              ) : (
                <div className="bg-green-100 text-green-800 px-3 py-1.5 rounded-full text-xs font-medium">
                  ✨ New Analysis
                </div>
              )}
            </div>

          </div>


          {/* IDEA META (CHIPS STYLE) */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3 mt-5">

            <div className="bg-slate-50 rounded-lg p-3">
              <div className="text-[11px] font-semibold text-slate-500 mb-1 uppercase">
                Problem
              </div>
              <div className="text-sm text-slate-700 line-clamp-2">
                {selectedIdea.problem}
              </div>
            </div>

            <div className="bg-slate-50 rounded-lg p-3">
              <div className="text-[11px] font-semibold text-slate-500 mb-1 uppercase">
                Target
              </div>
              <div className="text-sm text-slate-700 line-clamp-2">
                {selectedIdea.targetUser}
              </div>
            </div>

            <div className="bg-slate-50 rounded-lg p-3">
              <div className="text-[11px] font-semibold text-slate-500 mb-1 uppercase">
                Industry
              </div>
              <div className="text-sm text-slate-700 line-clamp-2">
                {selectedIdea.industry}
              </div>
            </div>

          </div>

        </div>
      )}

    </div>
  );
};

export default ModuleHeader;